import { RHMResource, RHMAction } from '@symposium/om-account-lib/om-auth-constants/om-auth-constants';
import { PATH_TYPE, NAV_ITEM_ID, TARGET } from './constants';
import { createItem } from './navigation';
export const aboutMenuItem = createItem({
  ariaLabel: 'About link',
  id: NAV_ITEM_ID.about,
  label: 'About',
  path: 'about'
});
export const accessMenuItem = createItem({
  ariaLabel: 'My team link',
  id: NAV_ITEM_ID.myTeam,
  label: 'My team',
  path: 'account/management',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_MEMBERSHIP,
    action: RHMAction.READ
  }
});
export const accessibilityMenuItem = createItem({
  ariaLabel: 'Accessibility link',
  id: NAV_ITEM_ID.accessibility,
  label: 'Accessibility',
  path: 'https://www.ibm.com/able',
  pathType: PATH_TYPE.absolute,
  target: TARGET.blank
});
export const blogMenuItem = createItem({
  ariaLabel: 'Blog link',
  id: NAV_ITEM_ID.blog,
  label: 'Blog',
  path: 'blog'
});
export const contactMenuItem = createItem({
  ariaLabel: 'Contact link',
  id: NAV_ITEM_ID.contact,
  label: 'Contact',
  path: 'https://www.ibm.com/contact/us/en/?lnk=flg-cont-usen',
  pathType: PATH_TYPE.absolute,
  target: TARGET.blank
});
export const accountSettingsMenuItem = createItem({
  ariaLabel: 'Account settings',
  id: NAV_ITEM_ID.accountSettings,
  label: 'Account settings',
  path: 'account/account-settings',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_SETTINGS,
    action: RHMAction.READ
  }
});
export const partnerAccountSettingsMenuItem = createItem({
  ariaLabel: 'Partner account settings',
  id: NAV_ITEM_ID.partnerAccountSettings,
  label: 'Account settings',
  path: 'account/partner-account-settings',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_SETTINGS,
    action: RHMAction.READ
  }
});
export const datasetsMenuItem = createItem({
  ariaLabel: 'Datasets link',
  id: NAV_ITEM_ID.datasets,
  label: 'Datasets',
  path: 'workspace/datasets'
});
export const deploymentKeysMenuItem = createItem({
  ariaLabel: 'Pull secrets link',
  id: NAV_ITEM_ID.deploymentKeys,
  label: 'Pull secrets',
  path: 'account/keys',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_CLUSTERS,
    action: RHMAction.READ
  }
});
export const documentationMenuItem = createItem({
  ariaLabel: 'Docs link',
  id: NAV_ITEM_ID.documentation,
  label: 'Docs',
  path: 'documentation'
});
export const partnerDocumentationMenuItem = createItem({
  ariaLabel: 'Partner docs link',
  id: NAV_ITEM_ID.partnerDocumentation,
  label: 'Docs',
  path: 'documentation/partner-docs'
});
export const myOffersMenuItem = createItem({
  ariaLabel: 'My offers link',
  id: NAV_ITEM_ID.myOffers,
  label: 'My offers',
  path: 'account/offers',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_ENTITLEMENTS,
    action: RHMAction.MANAGE
  }
});
export const creditsMenuItem = createItem({
  ariaLabel: 'Credits and discounts link',
  id: NAV_ITEM_ID.credits,
  label: 'Credits and discounts',
  path: 'account/credits',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_BILLING,
    action: RHMAction.READ
  }
});
export const feedbackMenuItem = createItem({
  ariaLabel: 'Feedback link',
  id: NAV_ITEM_ID.feedback,
  label: 'Feedback',
  path: 'feedback'
});
export const invoicesMenuItem = createItem({
  ariaLabel: 'Account invoice history link',
  id: NAV_ITEM_ID.invoices,
  label: 'Invoice history',
  path: 'account/invoices'
});
export const logoutMenuItem = createItem({
  ariaLabel: 'Log out link',
  icon: 'logout',
  id: NAV_ITEM_ID.logout,
  label: 'Log out',
  pathType: PATH_TYPE.absolute
});
export const customerSolutionsMenuItem = createItem({
  ariaLabel: 'Learn more about customer solutions link',
  id: NAV_ITEM_ID.customerSolutions,
  label: 'Customer solutions',
  path: 'customer-solutions'
});
export const enterpriseSolutionsMenuItem = createItem({
  ariaLabel: 'Learn more about enterprise solutions link',
  id: NAV_ITEM_ID.enterpriseSolutions,
  label: 'Enterprise solutions',
  path: 'enterprise-solutions'
});
export const learnMoreItems = [customerSolutionsMenuItem, enterpriseSolutionsMenuItem];
export const learnMoreMenuItem = createItem({
  ariaLabel: 'Learn more about Red Hat Marketplace link',
  id: NAV_ITEM_ID.learnMore,
  label: 'Learn more',
  path: 'learn-more',
  submenu: learnMoreItems
});
export const marketplaceMenuItem = createItem({
  ariaLabel: 'Marketplace link',
  id: NAV_ITEM_ID.marketplace,
  label: 'Marketplace',
  path: ''
});
export const myDashboardMenuItem = createItem({
  ariaLabel: 'Dashboard link',
  id: NAV_ITEM_ID.myDashboard,
  label: 'Dashboard',
  path: 'workspace/dashboard',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_BILLING,
    action: RHMAction.READ
  }
});
export const usageMenuItem = createItem({
  ariaLabel: 'Usage link',
  id: NAV_ITEM_ID.usage,
  label: 'Usage',
  path: 'workspace/dashboard/usage'
});
export const myClustersMenuItem = createItem({
  ariaLabel: 'Clusters link',
  id: NAV_ITEM_ID.myClusters,
  label: 'Clusters',
  path: 'workspace/clusters'
});
export const myRequestsMenuItem = createItem({
  ariaLabel: 'My requests link',
  id: NAV_ITEM_ID.myRequests,
  label: 'My requests',
  path: 'workspace/my-requests'
});
export const mySoftwareMenuItem = createItem({
  ariaLabel: 'Software link',
  id: NAV_ITEM_ID.mySoftware,
  label: 'Software',
  path: 'workspace/software'
});
export const myUpdatesMenuItem = createItem({
  ariaLabel: 'My updates link',
  id: NAV_ITEM_ID.myUpdates,
  label: 'My updates',
  path: 'workspace/updates'
});
export const partnerExperienceMenuItem = createItem({
  ariaLabel: 'Sell with us link',
  id: NAV_ITEM_ID.partnerExperience,
  label: 'Sell with us',
  path: '/partner',
  pathType: PATH_TYPE.absolute
});
export const paymentMethodMenuItem = createItem({
  ariaLabel: 'Payment method link',
  id: NAV_ITEM_ID.paymentMethod,
  label: 'Payment method',
  path: 'account/payment-method'
});
export const pendingChargesMenuItem = createItem({
  ariaLabel: 'Pending charges link',
  id: NAV_ITEM_ID.pendingCharges,
  label: 'Pending charges',
  path: 'account/pending-charges'
});
export const privacyPolicyMenuItem = createItem({
  ariaLabel: 'IBM Privacy policy link',
  id: NAV_ITEM_ID.privacy,
  label: 'IBM Privacy',
  path: 'privacy'
});
export const performanceMenuItem = createItem({
  ariaLabel: 'Performance link',
  id: NAV_ITEM_ID.performance,
  label: 'Performance',
  path: '/partner/dashboard',
  pathType: PATH_TYPE.absolute
});
export const privateOffersMenuItem = createItem({
  ariaLabel: 'Private offers link',
  id: NAV_ITEM_ID.privateOffers,
  label: 'Private offers',
  path: 'commerce/private-offer'
});
export const partnerProductsMenuItem = createItem({
  ariaLabel: 'Products link',
  id: NAV_ITEM_ID.partnerProducts,
  label: 'Products',
  path: '/partner/products',
  pathType: PATH_TYPE.absolute
});
export const profileMenuItem = createItem({
  ariaLabel: 'My profile link',
  id: NAV_ITEM_ID.profile,
  label: 'My profile',
  path: 'account/profile'
});
export const partnerProfileMenuItem = createItem({
  ariaLabel: 'My profile partner link',
  id: NAV_ITEM_ID.partnerProfile,
  label: 'My profile',
  path: 'account/partner-profile'
});
export const serviceIdItem = createItem({
  ariaLabel: 'Service ids link',
  id: NAV_ITEM_ID.serviceIds,
  label: 'Service IDs',
  path: 'account/service-ids',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_MEMBERSHIP,
    action: RHMAction.READ
  }
});
export const partnerServiceIdItem = createItem({
  ariaLabel: 'Partner Service ids link',
  id: NAV_ITEM_ID.partnerServiceIds,
  label: 'Service IDs',
  path: 'account/partner-service-ids',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_MEMBERSHIP,
    action: RHMAction.READ
  }
});
export const signInMenuItem = createItem({
  ariaLabel: 'Log in link',
  id: NAV_ITEM_ID.signIn,
  label: 'Log in',
  path: 'signin'
});
export const supportMenuItem = createItem({
  ariaLabel: 'Support link',
  id: NAV_ITEM_ID.support,
  label: 'Support',
  path: 'support'
});
export const systemStatusItem = createItem({
  ariaLabel: 'System status link',
  id: NAV_ITEM_ID.systemStatus,
  label: 'System status',
  path: 'https://status.marketplace.redhat.com/',
  pathType: PATH_TYPE.absolute,
  target: TARGET.blank
});
export const termsOfUseMenuItem = createItem({
  ariaLabel: 'IBM Terms link',
  id: NAV_ITEM_ID.terms,
  label: 'IBM Terms',
  path: 'terms'
});
export const rhmTermsOfServiceMenuItem = createItem({
  ariaLabel: 'RHM Terms link',
  id: NAV_ITEM_ID.rhmTerms,
  label: 'Terms',
  path: 'registration/rhm/termsofservice'
});
export const billingItems = [pendingChargesMenuItem, invoicesMenuItem, paymentMethodMenuItem];
export const billingMenuItem = createItem({
  ariaLabel: 'Billing link',
  id: NAV_ITEM_ID.billing,
  label: 'Billing',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_BILLING,
    action: RHMAction.READ
  },
  submenu: billingItems
});
export const customizationEditorMenuItem = createItem({
  ariaLabel: 'Customization editor link',
  id: NAV_ITEM_ID.marketplaceSelectCustomization,
  label: 'Customization',
  path: 'account/customization-editor',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_PRIVATE_CATALOG,
    action: RHMAction.MANAGE
  }
});
export const tagManagementMenuItem = createItem({
  ariaLabel: 'Tag management link',
  id: NAV_ITEM_ID.marketplaceSelectTagManagement,
  label: 'Tag management',
  path: 'account/tags',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_PRIVATE_CATALOG,
    action: RHMAction.MANAGE
  }
});
export const marketplaceSelectItems = [customizationEditorMenuItem, tagManagementMenuItem];
export const marketplaceSelectMenuItem = createItem({
  ariaLabel: 'Marketplace Select link',
  id: NAV_ITEM_ID.marketplaceSelect,
  label: 'Marketplace Select',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_PRIVATE_CATALOG,
    action: RHMAction.MANAGE
  },
  submenu: marketplaceSelectItems
});
export const customerAccessItems = [accessMenuItem, serviceIdItem];
export const workspaceItems = [myDashboardMenuItem, mySoftwareMenuItem, datasetsMenuItem, usageMenuItem, myClustersMenuItem];
export const customerAccessMenuItem = createItem({
  ariaLabel: 'Access link',
  id: NAV_ITEM_ID.access,
  label: 'Access',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_MEMBERSHIP,
    action: RHMAction.READ
  },
  submenu: customerAccessItems
});
export const myAccountMenuItem = createItem({
  ariaLabel: 'My account link',
  id: NAV_ITEM_ID.myAccount,
  label: 'My account',
  path: 'account/profile'
});
export const workspaceMenuItem = createItem({
  ariaLabel: 'Workspace link',
  id: NAV_ITEM_ID.workspace,
  label: 'Workspace',
  path: 'workspace/software',
  submenu: []
});
export const myCompanyLinkItem = createItem({
  ariaLabel: 'My company link',
  id: NAV_ITEM_ID.myCompany,
  label: 'My company',
  path: '/partner/company/details',
  pathType: PATH_TYPE.absolute,
  iamPermissions: {
    resource: RHMResource.VENDOR_PRODUCT_EDITOR,
    action: RHMAction.MANAGE
  }
});
export const partnerMyTeamItem = createItem({
  ariaLabel: 'My team link',
  id: NAV_ITEM_ID.partnerMyTeam,
  label: 'My team',
  path: 'account/partner-management',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_MEMBERSHIP,
    action: RHMAction.READ
  }
});
export const partnerAccessItems = [partnerMyTeamItem, partnerServiceIdItem];
export const partnerAccessMenuItem = createItem({
  ariaLabel: 'Access link',
  id: NAV_ITEM_ID.partnerAccess,
  label: 'Access',
  iamPermissions: {
    resource: RHMResource.ACCOUNT_MEMBERSHIP,
    action: RHMAction.READ
  },
  submenu: partnerAccessItems
});
export const partnerLegalLinkItem = createItem({
  ariaLabel: 'Legal link',
  id: NAV_ITEM_ID.legal,
  label: 'Legal',
  path: '/partner/company/legal',
  pathType: 'absolute',
  iamPermissions: {
    resource: RHMResource.VENDOR_LEGAL,
    action: RHMAction.MANAGE
  }
});
export const paymentSettingsLinkItem = createItem({
  ariaLabel: 'Payment settings link',
  id: NAV_ITEM_ID.paymentSettings,
  label: 'Payment settings',
  path: '/partner/company/payments',
  pathType: 'absolute',
  iamPermissions: {
    resource: RHMResource.VENDOR_PRODUCT_EDITOR,
    action: RHMAction.MANAGE
  }
});
export const internationalSellingLinkItem = createItem({
  ariaLabel: 'International selling link',
  id: NAV_ITEM_ID.internationalSelling,
  label: 'International selling',
  path: '/partner/company/international',
  pathType: 'absolute',
  iamPermissions: {
    resource: RHMResource.VENDOR_PRODUCT_EDITOR,
    action: RHMAction.MANAGE
  }
});
export const accountSettingsItems = [accountSettingsMenuItem, customerAccessMenuItem, myOffersMenuItem, creditsMenuItem, billingMenuItem, deploymentKeysMenuItem, marketplaceSelectMenuItem];
export const myAccountMenuItems = createItem({
  ariaLabel: 'My account menu link',
  id: NAV_ITEM_ID.myAccount,
  label: 'My account',
  submenu: accountSettingsItems
});
export const partnerSidenavItems = [partnerAccountSettingsMenuItem, myCompanyLinkItem, partnerAccessMenuItem, partnerLegalLinkItem, paymentSettingsLinkItem, internationalSellingLinkItem];
export const vendorNavigationItems = [partnerProductsMenuItem, privateOffersMenuItem, partnerDocumentationMenuItem];
const menuItems = {
  aboutMenuItem,
  accessMenuItem,
  accessibilityMenuItem,
  blogMenuItem,
  contactMenuItem,
  billingMenuItem,
  datasetsMenuItem,
  deploymentKeysMenuItem,
  documentationMenuItem,
  partnerDocumentationMenuItem,
  accountSettingsMenuItem,
  partnerAccountSettingsMenuItem,
  feedbackMenuItem,
  invoicesMenuItem,
  learnMoreItems,
  learnMoreMenuItem,
  partnerAccessMenuItem,
  partnerLegalLinkItem,
  internationalSellingLinkItem,
  logoutMenuItem,
  marketplaceMenuItem,
  myAccountMenuItem,
  myDashboardMenuItem,
  usageMenuItem,
  myClustersMenuItem,
  myCompanyLinkItem,
  myRequestsMenuItem,
  mySoftwareMenuItem,
  partnerMyTeamItem,
  serviceIdItem,
  partnerServiceIdItem,
  myUpdatesMenuItem,
  paymentMethodMenuItem,
  paymentSettingsLinkItem,
  pendingChargesMenuItem,
  performanceMenuItem,
  privacyPolicyMenuItem,
  privateOffersMenuItem,
  partnerProductsMenuItem,
  myOffersMenuItem,
  creditsMenuItem,
  partnerExperienceMenuItem,
  profileMenuItem,
  partnerProfileMenuItem,
  signInMenuItem,
  supportMenuItem,
  systemStatusItem,
  termsOfUseMenuItem,
  workspaceMenuItem,
  myAccountMenuItems,
  accountSettingsItems,
  workspaceItems,
  partnerSidenavItems,
  vendorNavigationItems,
  customizationEditorMenuItem,
  tagManagementMenuItem,
  marketplaceSelectItems,
  marketplaceSelectMenuItem,
  rhmTermsOfServiceMenuItem,
  customerAccessMenuItem
};
export default menuItems;